export const styles = {
  tableWrapper: {
    height: 'inherit',
    '& .MuiTableContainer-root': {
      height: 'inherit',
    },
    position: 'relative',
  },
  selectWrap: {
    display: 'flex',
  },
  inputWrap: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: 20,
    height: '50px',
  },
  multipleSelect: {
    color: '7F8FA4',
    fontSize: 16,
    cursor: 'pointer',
  },
  saveButton: {
    display: 'flex',
    marginBottom: 10,
  },
  stageSelect: {
    marginLeft: 10,
  },
  error: {
    color: 'red',
  },
}
